/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { CornDDGS } from "./modelCornDDGS";

class ControllerCornDDGS extends ControllerModel {
  constructor() {
    super("ControllerCornDDGS");
    
    this.setNewNode = (callback) => {
      let vasteurization = new CornDDGS();
      vasteurization.decorate(callback);

      this.addNode(vasteurization);
    }

    this.loadNode = (node, callback) => {
      let vasteurization = new CornDDGS();
      vasteurization.copyFrom(node);
      vasteurization.decorate(callback);
      this.addNode(vasteurization)
    }

    this.getProperties = async (node) => {
      let n = new CornDDGS();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new CornDDGS();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerCornDDGS };
